import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7b28e42f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"color":"#E54545"}
}

import CmSvgIcon from '@/components/cm-svg-icon/cm-svg-icon.vue'

import { reactive, ref, computed, h, PropType } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { ElMessage, ElMessageBox } from 'element-plus'
import dayjs from 'dayjs'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import GroupTreeSelector from '@/views/dashboard/_components/group-tree-selector/group-tree-selector.vue'
import {
  ExaminationService,
  FetchOptions,
  ExaminationItem,
  UnfixedReasonTop,
  EXAM_REASON_I18N_KEY,
} from '../examination-status.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { useRoute } from 'vue-router'
import {
  ActionType,
  ActionTypeValuesByKeys,
  FormSize,
  FormType,
  ObjectFormItem,
} from '@/components/cmForm/types'
import { TableOpt, TableActOpt } from '@/components/cmTable/types'
import { TableViewMode, TableViewModeType } from '@/views/dashboard/_enum/table-view-mode'
import { listCol, listColPair } from '@/utils/list-columns-i18n'
import { formatTimeStamp } from '@/utils/time'

const EXAMINATION_LOADING = 2


export default /*#__PURE__*/_defineComponent({
  __name: 'examination-table',
  props: {
  viewMode: {
    type: String as PropType<TableViewModeType>,
    default: TableViewMode.preview
  },
  /** 全量抽屉由图表带参打开时传入，覆盖默认/route 初始筛选项（与 key 联动） */
  initialQueryPatch: {
    type: Object as PropType<Partial<FetchOptions>>,
    default: undefined,
  },
  /** 与体检汇总未修复原因 TOP 同源，作为「未修复原因」筛选项 */
  unfixedReasonOptions: {
    type: Array as PropType<UnfixedReasonTop[] | undefined>,
    default: undefined,
  },
},
  emits: ['viewAll', 'viewDetail', 'updatePreview'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t, locale } = useI18n()

function examStatusName(status: number): string {
  const keys = [
    'statusNone',
    'statusNotExamined',
    'statusExamining',
    'statusCompleted',
    'statusTimeout',
  ] as const
  const key = keys[status]
  return key ? t(`examinationTable.${key}`) : '--'
}

const props = __props

const emits = __emit

const route = useRoute()

const injector = useReflectiveInjector()
const examinationService = injector.get(ExaminationService)
const dataApi = examinationService.getList.bind(examinationService)

const tableRef = ref()

const { refreshList } = useCmTableListRefresh(tableRef)
const queryParams = reactive<Partial<FetchOptions>>({
  group_id: -1,
  key_word: '',
  page: 1,
  limit: props.viewMode === TableViewMode.preview ? 10 : 20,
  sort: '',
  asc: false,
  login_status: undefined,
  score_range: props.viewMode === TableViewMode.preview ? undefined : (Number(route.query.score_range) || undefined),
  is_exam: undefined,
  system_type: 1,
  reason: undefined,
})

if (
  props.viewMode === TableViewMode.full &&
  props.initialQueryPatch &&
  Object.keys(props.initialQueryPatch).length > 0
) {
  Object.assign(queryParams, props.initialQueryPatch)
}

const selectedRows = ref<ExaminationItem[]>([])
const isSelectAll = ref(false)

const state = reactive({
  refreshInterval: null as any,
  loadingIds: [] as string[],
})

function unrepairedReasonLabel(reason: string): string {
  const key = EXAM_REASON_I18N_KEY[reason]
  return key ? t(key) : t('examinationTable.unknownReason')
}

const filterFormColumns = computed<Partial<ObjectFormItem<FetchOptions, keyof FetchOptions>>>(() => {
  void locale.value
  const topReasons = [...(props.unfixedReasonOptions || [])].sort((a, b) => b.count - a.count).slice(0, 5)
  let unfixedDict = topReasons.map((item) => ({
    label: unrepairedReasonLabel(item.reason),
    value: item.reason,
  }))
  const currentUnfixed = queryParams.reason
  if (currentUnfixed && !unfixedDict.some((d) => d.value === currentUnfixed)) {
    unfixedDict = [
      ...unfixedDict,
      { label: unrepairedReasonLabel(currentUnfixed), value: currentUnfixed },
    ]
  }
  return {
    group_id: {
      colOpt: { style:'flex:0 0 150px' },
      slot: true,
      label: t('examinationTable.filterGroup'),
      hiddenAllLabel: true,
      outSearchFiledFlag: true,
      events: {
        change: handleQuery
      },
    },
    score_range: {
      colOpt: { span: 12 },
      label: t('examinationTable.filterExamScore'),
      type: FormType.Select,
      selectOpt: { clearable: true },
      dictData: [
        { label: t('examinationTable.scoreFull'), value: 3 },
        { label: t('examinationTable.score60to99'), value: 2 },
        { label: t('examinationTable.scoreBelow60'), value: 1 },
      ],
    },
    reason: {
      colOpt: { span: 12 },
      label: t('examinationTable.filterUnfixedReason'),
      type: FormType.Select,
      selectOpt: { clearable: true },
      dictData: unfixedDict,
    },
    login_status: {
      colOpt: { span: 12 },
      label: t('examinationTable.filterTerminalStatus'),
      type: FormType.Select,
      selectOpt: { clearable: true },
      dictData: [
        { label: t('examinationTable.online'), value: 1 },
        { label: t('examinationTable.offline'), value: 2 }
      ]
    },
    is_exam: {
      colOpt: { span: 12 },
      label: t('examinationTable.filterExamStatus'),
      type: FormType.Select,
      selectOpt: { clearable: true },
      dictData: [
        { label: t('examinationTable.examined'), value: 1 },
        { label: t('examinationTable.notExamined'), value: 2 }
      ]
    }
  }
})

const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
    columnOpt: { label: listCol(t, 'operation'), width: 100, align: 'left', fixed: 'right' },
    actionButtons: (row: ExaminationItem) => [
      {
        name: t('examinationTable.viewDetail'),
        disabled: () => row.physical_exam_status !== 3,
        type: ActionType.Detail,
        opt: { size: FormSize.Small, text: true, type: 'text' },
      }
    ]
  }
})

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : 'background: transparent;padding:0',
    path: 'list',
    height: props.viewMode === TableViewMode.preview ? undefined : '100%',
    showActionBar: false,
    showForm: false,
    showRightToolbar: false,
    rowKey: 'device_id',
    selection: true,
    showTip: true,
    usePagination: false,
    disableScrollLoad: props.viewMode === TableViewMode.preview,
    scrollLoadThreshold: 10,
    scrollLoadDelay: 100,
    columns: [
      {
        label: listCol(t, 'computerName'),
        prop: 'computer_name',
        type: 'COMPUTER',
        columnOpt: { minWidth: 160 },
        showOverflow: true
      },
      {
        label: listCol(t, 'userMark'),
        prop: 'user_mark',
        columnOpt: { minWidth: 120 }
      },
      {
        label: listCol(t, 'ipAddress'),
        prop: 'client_ip', type: "IP",
        columnOpt: { minWidth: 140 },
      },
      {
        label: listCol(t, 'lastExamTime'),
        prop: 'examination_time',
        columnOpt: { minWidth: 160 },
        formatter: (row: any, value: number) =>
          !value || row.physical_exam_status < 3 ? '--' : formatTimeStamp(value, 'YYYY-MM-DD HH:mm'),
      },
      {
        label: listCol(t, 'examStatus'),
        prop: 'physical_exam_status',
        columnOpt: { minWidth: 130 }
      },
      {
        label: listCol(t, 'lastExamScore'),
        prop: 'score',
        columnOpt: { minWidth: 100 }
      }
    ]
  }
})

function calcDateDiff(examination_time: number): boolean {
  return dayjs().subtract(7, 'day').valueOf() > (examination_time * 1000)
}

function calcScoreColor(score: number): string {
  if (!score) return 'zero-score'
  return score > 79 ? 'green-score' : (score > 60 ? 'yellow-score' : 'red-score')
}

function updateLoadingStatus() {
  const tableData = tableRef.value?.rowData?.list || []
  tableData.forEach((item: ExaminationItem) => {
    if (state.loadingIds.includes(item.device_id) && item.login_status === 1) {
      item.physical_exam_status = EXAMINATION_LOADING
    }
  })
  if (props.viewMode === TableViewMode.full) {
    emits('updatePreview')
  }
}

function getExaminationResult() {
  if (state.loadingIds.length) {
    if (state.refreshInterval) {
      clearInterval(state.refreshInterval)
    }

    state.refreshInterval = setInterval(() => {
      if (!state.loadingIds.length) {
        clearInterval(state.refreshInterval)
        state.refreshInterval = null
        return
      }

      examinationService.getExaminationResult({ device_ids: state.loadingIds }).then((res: any) => {
        if (res?.list && res.list.length) {
          const stillLoading = res.list.filter(
            (resultItem: any) => resultItem.physical_exam_status === EXAMINATION_LOADING
          )
          state.loadingIds = stillLoading.map((resultItem: any) => resultItem.device_id)

          const tableData = tableRef.value?.rowData?.list
          if (tableData) {
            res.list.forEach((resultItem: any) => {
              const updateItem = tableData.find((item: ExaminationItem) => item.device_id === resultItem.device_id)
              if (updateItem) {
                Object.assign(updateItem, resultItem)
              }
            })
          }
          if (props.viewMode === TableViewMode.full) {
            emits('updatePreview')
          }
        }
      }).catch(() => {
        // 轮询失败，继续下一轮
      })
    }, 1000)
  }
}

async function handleSearch(value: string) {
  queryParams.key_word = value
  await refreshList()
}

async function handleQuery(form: any) {
  Object.assign(queryParams, form)
  await refreshList()
}

function handleReset() {
  queryParams.key_word = ''
  queryParams.score_range = undefined
  queryParams.login_status = undefined
  queryParams.is_exam = undefined
  queryParams.reason = undefined
  void refreshList()
}

async function updateGroupId(groupId: number) {
  queryParams.group_id = groupId
  queryParams.page = 1
  await refreshList()
}

function changeSelected(selection = [], _ids = [], isAll: boolean) {
  selectedRows.value = selection
  isSelectAll.value = isAll
}

function handleRepairTerminal() {
  const count = isSelectAll.value ? tableRef.value.total : selectedRows.value.length
  if (!count) {
    ElMessage.warning(t('examinationTable.selectTerminalFirst'))
    return
  }

  ElMessageBox({
    title: t('safeProtectionModule.tip'),
    iconClass: null,
    showCancelButton: true,
    message: h('div', { style: 'display:flex;align-items:center;margin-left:10px;margin-top:25px;margin-bottom:20px' }, [
      h(CmSvgIcon, { name: 'views/dashboard/safe-status/_images/client_modal_tip', size: 20, monochrome: true }),
      h('div', { style: 'margin-left:10px' }, [
        h('p', null, t('examinationTable.examDispatchLine1', { n: count })),
        h('p', null, t('examinationTable.examDispatchLine2'))
      ])
    ]),
    confirmButtonText: t('common.submit'),
    cancelButtonText: t('common.cancel'),
  }).then(() => {
    const deviceIds = selectedRows.value.map(item => item.device_id)
    state.loadingIds = deviceIds

    examinationService.repairTerminal({
      execute_type: 0,
      device_list: deviceIds,
      group_id: isSelectAll.value ? queryParams.group_id : undefined,
      is_repair: false
    }).then(() => {
      ElMessage.success(t('examinationTable.examDispatchSuccess', { n: count }))
      setTimeout(() => {
        updateLoadingStatus()
        getExaminationResult()
      }, 500)
      void refreshList(false)
      if (props.viewMode === TableViewMode.full) {
        emits('updatePreview')
      }
    }).catch(() => {
      ElMessage.error(t('examinationTable.examDispatchFail', { n: count }))
    })
  })
}

function handleBatchRepair() {
  const count = isSelectAll.value ? tableRef.value.total : selectedRows.value.length
  if (!count) {
    ElMessage.warning(t('examinationTable.selectTerminalFirst'))
    return
  }

  const selectedRowsData = selectedRows.value
  const filteredData = selectedRowsData.filter((item: ExaminationItem) => {
    if (item.physical_exam_status === 1) return false
    if (item.score === 100) return false
    return true
  })

  if (filteredData.length === 0) {
    ElMessage.warning(t('examinationTable.repairNoEligible'))
    return
  }

  const filteredIds = filteredData.map((item: ExaminationItem) => item.device_id)

  ElMessageBox({
    title: t('safeProtectionModule.tip'),
    iconClass: null,
    showCancelButton: true,
    message: h('div', { style: 'display:flex;align-items:center;margin-left:10px;margin-top:25px;margin-bottom:20px' }, [
      h(CmSvgIcon, { name: 'views/dashboard/safe-status/_images/client_modal_tip', size: 20, monochrome: true,style:'width: 40px;height:40pxv3.9.9-private;color:var(--cm-color-primary)' }),
      h('div', { style: 'margin-left:10px;' }, [
        h('p', null, t('examinationTable.repairDispatchLine1', { n: filteredData.length })),
        h('p', null, t('examinationTable.repairDispatchLine2')),
        h('p', null, t('examinationTable.repairDispatchLine3'))
      ])
    ]),
    confirmButtonText: t('common.confirm'),
    cancelButtonText: t('common.cancel'),
  }).then(() => {
    examinationService.repairTerminal({
      execute_type: 0,
      device_list: filteredIds,
      group_id: queryParams.group_id as number,
      is_repair: true
    }).then(() => {
      ElMessage.success(t('examinationTable.repairDispatchSuccess', { n: filteredData.length }))
      setTimeout(() => {
        updateLoadingStatus()
        getExaminationResult()
      }, 500)
      void refreshList(false)
      if (props.viewMode === TableViewMode.full) {
        emits('updatePreview')
      }
    }).catch(() => {
      ElMessage.error(t('examinationTable.repairDispatchFail', { n: filteredData.length }))
    })
  })
}

function handleAction({ type, rowItem }: { type: ActionTypeValuesByKeys, rowItem?: ExaminationItem }) {
  if (type === ActionType.Detail) {
    emits('viewDetail', rowItem as ExaminationItem)
  }
}

__expose({
  tableRef,
  getList: () => void refreshList(),
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    tableOpt: tableOpt.value,
    tableActOpt: tableActOpt.value,
    api: _unref(dataApi),
    modelValue: queryParams,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams) = $event)),
    pageOption: {
      style: 'padding-bottom: 16px',
      pageNumName: 'page',
      pageSizeName: 'limit',
    },
    onHandleAction: handleAction,
    onChangeSelected: changeSelected
  }, {
    header: _withCtx(() => [
      _createVNode(SearchFilterBar, {
        modelValue: queryParams,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams) = $event)),
        "form-columns": filterFormColumns.value,
        "show-search": true,
        "search-placeholder": _ctx.$t('common.phExamSearch'),
        "popover-threshold": 0,
        onSearch: handleSearch,
        onQuery: handleQuery,
        onReset: handleReset
      }, {
        group_id: _withCtx(() => [
          _createVNode(GroupTreeSelector, {
            width: "100%",
            "terminal-type": [1, 3],
            onSelected: updateGroupId
          })
        ]),
        actions: _withCtx(() => [
          _createVNode(_component_el_button, {
            disabled: !selectedRows.value.length,
            size: "small",
            type: "primary",
            onClick: handleRepairTerminal
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('examinationTable.examNow')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            disabled: !selectedRows.value.length,
            size: "small",
            type: "primary",
            class: "cm-ui-ml10",
            onClick: handleBatchRepair
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('examinationTable.repairNow')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          (__props.viewMode === _unref(TableViewMode).preview)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: "small",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewAll')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('examinationTable.viewAllTerminals')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "form-columns", "search-placeholder"])
    ]),
    physical_exam_status: _withCtx(({ row }) => [
      ((row.physical_exam_status === 3 || row.physical_exam_status === 4) && calcDateDiff(row.examination_time))
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('examinationTable.overdueNoExam')), 1))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            style: _normalizeStyle(row.physical_exam_status === 2 ? { color: '#FF9D00' } : (row.physical_exam_status === 1 ? { color: '#E54545' } : {}))
          }, _toDisplayString(examStatusName(row.physical_exam_status)), 5))
    ]),
    score: _withCtx(({ row }) => [
      (row.physical_exam_status === 3)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(`score-badge ${calcScoreColor(row.score)}`)
          }, _toDisplayString(row.score) + _toDisplayString(_ctx.$t('examinationTable.scoreUnit')), 3))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" -- ")
          ], 64))
    ]),
    _: 1
  }, 8, ["tableOpt", "tableActOpt", "api", "modelValue"]))
}
}

})